import { Layout } from 'react-grid-layout';
import { isEqual, pick } from 'lodash';

export type PanelLayout = { sm: Omit<Layout, 'i'>; lg: Omit<Layout, 'i'> };

export interface QueryHistoryEntry {
  /** ISO 8601 timestamp */
  timestamp: string;
  /** mn_user.id of the user who made this change */
  user_id: string;
  /** LLM-generated summary of what changed (or fallback structured diff) */
  summary: string;
  /** Snapshot of config.data at this point in time */
  query: unknown;
  /** Snapshot of config.chart at this point in time */
  chart?: unknown;
  /** LLM-generated title for this query state */
  autoTitle: string;
  /** The user's prompt that generated this query state, can be blank */
  user_prompt: string;
}

export interface VariableMapping {
  variableName: string;
  filterField: string;
  operator?: string;
  disabled?: boolean;
}

export interface PanelData {
  id: number;
  company_id: string;
  user_id: string;
  board_id: string;
  parent_panel_id: string | null;
  type: 'ude' | 'widget' | 'section' | 'text';
  title: string;
  layout: PanelLayout;
  config: {
    // panel is collapsed in the board view
    collapsed?: boolean;
    // a default panel from an automatically generated observation deck
    isDefault?: boolean;
    widgetName?: string;
    variableMappings?: VariableMapping[];
    [key: string]: unknown;
  };
  // if this is a draft panel and a saved panel exists, this will be the saved panel data for comparison
  savedPanel?: PanelData;
  history?: QueryHistoryEntry[];
  cdate: Date;
  edate: Date;
}

export function isLayoutEqual(a: PanelLayout, b: PanelLayout): boolean {
  const compareKeys = ['sm.x', 'sm.y', 'sm.w', 'sm.h', 'lg.x', 'lg.y', 'lg.w', 'lg.h'];
  const normalizedA = pick(a, compareKeys);
  const normalizedB = pick(b, compareKeys);
  return isEqual(normalizedA, normalizedB);
}
